import customHeaders, { getSpace } from '../../common/headers';
import Cookies from 'universal-cookie';
import { LogoBox } from '../Logo/Logo';
import { ModalNotifications, DropDownSelector } from '@lk-gtcom/ecomlab-components';
import { ProfileSettings } from '../ProfileSettings/ProfileSettings';
import { NotificationContext } from '../../App';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect, useContext, useLayoutEffect } from 'react';
import { ButtonDrop } from '../Buttons/ButtonDrop/ButtonDrop';
import { ArtemBilling2Https } from '../../fetchUrls';
import { ModalUnboardingForSpace } from '../Modal/ModalUnboardingForSpace/ModalUnboardingForSpace';
import info_blue from './img/info-blue.svg';
import user_icon from './img/bx-user.svg.svg';
import user_circle_icon from './img/bx-user-circle.svg.svg';
import useGeneralStore from '../../store/general';
import settings from './img/settings.svg';
import { useShallow } from 'zustand/react/shallow';
import question from './img/question.svg'
import load from './img/load.svg'
import bell from './img/bell.svg'
import burger from './img/bx-menu.svg';
import close_green from './img/bx-x.svg';
import connected from './img/connected.svg'
import disconnected from './img/disconnected.svg'
import time_icon from './img/time.svg'
import { useAuth } from '../../common/auth';
import { useResponseHandler } from '../../common/auth';
import { Tooltip } from '../TooltipV2/Tooltip';

import './HeaderMain.scss';
import { ButtonWithIcon } from '../Buttons/ButtonWithIcon/ButtonWithIcon';
import { NotificationChat } from '../NotificationChat/NotificationChat';

const HeaderMain = ({
  setIsModalKnowledgeBase,
  setIsModalCreatingNewSpace,
  spaceList,
  isModalUnboardingForSpace,
  setIsModalUnboardingForSpace,
  isOpenMainMenu,
  setIsOpenMainMenu,
  setIsEditSpace,
  setIsModalChat
}) => {

  const { onLogOutHandler } = useAuth();
  const { showNotificationBox, setShowNotificationBox } = useContext(NotificationContext);
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const { currentSpace, setCurrentSpace, setPageValue1, setIsAuthorSpase } =
    useGeneralStore(
      useShallow((state) => ({
        currentSpace: state.currentSpace,
        setCurrentSpace: state.setCurrentSpace,
        setPageValue1: state.setPageValue1,
        setIsAuthorSpase: state.setIsAuthorSpase
      }))
    );

  const [profileName, setProfileName] = useState('');
  const [showProfileSettings, setProfileSettings] = useState(false);
  const [optionList, setOptionsList] = useState([]);
  const [balance, setBalance] = useState(0);
  const [currency, setCurrency] = useState('₽');
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const cookies = new Cookies();
  const client_id = localStorage.getItem('client_id');
  const [localSelectedSpace, setLocalSelectedSpace] = useState({});
  // const [tariffInSpace, setTariffInSpace] = useState([])
  // const [statusTariff, setStatusTariff] = useState(false)

  const {
    selectedSpace,
    setSelectedSpace,
    notifCount,
    setNotifCount,
    setSpaceList,
    isChangeNotification,
    setIsChangeNotification,
    statusTariff,
    setStatusTariff,
    tariffInSpace,
    setTariffInSpace,
    isPending,
    setisPending,
  } = useGeneralStore(
    useShallow((state) => ({
      selectedSpace: state.selectedSpace,
      setSelectedSpace: state.setSelectedSpace,
      notifCount: state.notificationCounter,
      setNotifCount: state.setNotificationCounter,
      setSpaceList: state.setSpaceList,
      isChangeNotification: state.isChangeNotification,
      setIsChangeNotification: state.setIsChangeNotification,
      statusTariff: state.statusTariff,
      setStatusTariff: state.setStatusTariff,
      tariffInSpace: state.tariffInSpace,
      setTariffInSpace: state.setTariffInSpace,
      isPending: state.isPending,
      setisPending: state.setisPending,
    }))
  );
  console.log(notifCount)
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  useEffect(() => {
    setOptionsList(
      spaceList?.map(({ id, name, author }) => {
        return {
          label: name,
          labelValue: name,
          value: id,
          author: author,
          icon: client_id == author?.id ? user_circle_icon : user_icon
        };
      })
    );
  }, [spaceList]);

  useEffect(() => {
    optionList?.forEach((el) => {
      const { value } = el;
      if (+selectedSpace?.value === +value) {
        setLocalSelectedSpace(el);
      }
    });
  }, [optionList]);

  useEffect(() => {
    if (selectedSpace && Object.keys(selectedSpace)?.length === 0) {
      const spaceWithoutLabel = { ...optionList[0] };
      delete spaceWithoutLabel.label;

      setLocalSelectedSpace(optionList[0]);
      setSelectedSpace(spaceWithoutLabel);
    }
  }, [optionList, localSelectedSpace]);

  const space = selectedSpace?.value
    ?
    spaceList.filter((el) => el?.id == selectedSpace?.value)
    : null

  const list_btn = [
    {
      label: 'Добавить новое пространство',
      func: () => {
        setCurrentSpace(null)
        navigate('/settings/space');
        setIsEditSpace(false)
        setPageValue1('employee')
        setIsModalCreatingNewSpace(true);
      },
    },
    {
      label: space?.[0]?.is_admin ? 'Добавить подключение' : 'Посмотреть подключения',
      func: () => {
        if (space?.[0]) {
          setCurrentSpace(space?.[0])
        }
        navigate('/settings/space');
        setIsEditSpace(true)
        setPageValue1('settings')
        // navigate('/settings/connections');
        // setIsModalActive(true);
        setIsModalCreatingNewSpace(true);
      },
    },
    {
      label: space?.[0]?.is_admin ? 'Добавить сотрудника' : 'Посмотреть сотрудников',
      func: () => {
        if (space?.[0]) {
          setCurrentSpace(space?.[0])
        }
        navigate('/settings/space');
        setIsEditSpace(true)
        setPageValue1('employee')
        setIsModalCreatingNewSpace(true);
      },
    },
  ];

  const path = useParams();

  useEffect(() => {
    if (path['*'] == 'settings/space/account') {
      if (selectedSpace?.value) {
        const space = spaceList.filter((el) => el?.id == selectedSpace?.value)
        setCurrentSpace(space?.[0])
      }
      navigate('/settings/space');
      setIsEditSpace(true)
      setPageValue1('settings')
      setIsModalCreatingNewSpace(true);
    }
  }, [path['*']]);

  const FETCH_INTERVAL_MS = 10000;

  // Каунтер сообщений
  const fetchNotificationsCount = () => {
    let url = ` https://portals.ecomru.ru/api/v2/article/get_count_unread_msg?status=unreaded`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setNotifCount(json);
      })
      .catch((err) => console.error(err));
  };

  // Баланс
  const fetchBalanceCount = () => {
    let url = `${ArtemBilling2Https}/balance`;

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then(({ balance, currency }) => {
        setBalance(balance?.toLocaleString());
        setCurrency(currency === 'RUB' ? '₽' : currency);
      })
      .catch((err) => console.error(err));
  };

  // Статус тарифа
  const fetchGetstatus = () => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/active/status`;

    fetch(url, { method: 'GET', headers, })
      .then(handleTableResponse)
      .then((json) => setStatusTariff(json?.has_active))
      .catch(handleRequestError)
  }

  // Получение тарифов пространства
  const fetchGetModelsTariffInSpace = (id) => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/info`;

    fetch(url, { method: 'GET', headers, })
      .then(handleTableResponse)
      .then((json) => {
        setTariffInSpace(json)
      })
      .catch(handleRequestError)
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchGetstatus()
      fetchGetModelsTariffInSpace()
    }, 30000) // 30 секунд

    return () => clearInterval(intervalId)
  }, [selectedSpace]);

  useEffect(() => {
    fetchGetstatus()
    fetchGetModelsTariffInSpace()
  }, [selectedSpace]);

  useEffect(() => {
    let profile = localStorage.getItem('email');
    setProfileName(profile);

    let intervalId;

    fetchBalanceCount();

    intervalId = setInterval(() => {
      fetchBalanceCount();
    }, FETCH_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
    };
  }, [selectedSpace]);

  useEffect(() => {
    setTimeout(() => fetchNotificationsCount(), 300)
  }, [isChangeNotification, selectedSpace]);

  useEffect(() => {
    fetchBalanceCount();
  }, [selectedSpace]);

  const closeHeaderItems = (e) => {
    let el = e.target;
    if (!el.closest('.profile-box__btn') && !el.closest('.profile-box__user-name')) {
      setProfileSettings(false);
    }

    if (el.closest('.notif') || el.closest('.notification-list')) {
      if (el.closest('.notification-item') || el.closest('.link-blue')) {
        setShowNotificationBox(false);
      } else {
        setShowNotificationBox(true);
      }
    } else {
      setShowNotificationBox(false);
    }
  };

  const returnStatus = (status) => {
    if (status === 'active') {
      return [connected, `Тариф активирован.`]
    }
    if (status === 'awaiting_payment') {
      return [time_icon, 'У вас есть неоплаченный тариф']
    }
    if (status === 'not_found') {
      return [disconnected, 'Тариф не активирован']
    }
  }

  useEffect(() => {
    document.addEventListener('click', closeHeaderItems);
    return () => {
      document.addEventListener('click', closeHeaderItems);
    };
  }, []);

  return (
    <>
      {isModalUnboardingForSpace && (
        <ModalUnboardingForSpace
          setIsModal={(e) => setIsModalUnboardingForSpace(e)}
        />
      )}

      {
        showNotificationBox &&
        <ModalNotifications
          notifCount={notifCount}
          isOpen={showNotificationBox}
          setIsOpen={setShowNotificationBox}
          portal_id={4}
          language={'ru'}
          headers_current={headers}
          fetchNotificationsCount={(e) => fetchNotificationsCount()}
          isChangeNotification={isChangeNotification}
          setIsChangeNotification={setIsChangeNotification}
        />
      }

      <div className="main-sidebar">
        <nav className="main-sidebar__nav">
          <div className="logo-and-search">
            <LogoBox />

            <DropDownSelector
              className='main-sidebar__select'
              state={localSelectedSpace}
              options_prop={optionList}
              setState={(e) => {
                if (Object.keys(e)?.length > 0) {
                  let obj = Object.assign({}, e);
                  delete obj?.label;

                  setSelectedSpace(obj);
                  setLocalSelectedSpace(e);
                  navigate('/landing/charts');
                }
              }}
              placeholder="Выберите пространство"
              isClearable={false}
              maxWidth='160px'
            />

            <ButtonWithIcon
              className='main-sidebar__burger-btn'
              icon={isOpenMainMenu ? close_green : burger}
              onClick={(e) => setIsOpenMainMenu(!isOpenMainMenu)}
            />
          </div>

          <div className="main-sidebar__space-content">
            <DropDownSelector
              state={localSelectedSpace}
              options_prop={optionList}
              setState={(e) => {
               
                if (Object.keys(e)?.length > 0) {
                  let obj = Object.assign({}, e);
                  delete obj?.label;

                  setSelectedSpace(obj);
                  setLocalSelectedSpace(e); 
                  setIsAuthorSpase(e?.author?.id == client_id)
                  navigate('/landing/charts');
                }
              }}
              placeholder="Выберите пространство"
              isClearable={false}
            />

            <ButtonDrop list_btn={list_btn} />

            <button
              className="main-sidebar__btn-info"
              onClick={(e) => setIsModalUnboardingForSpace(true)}
            >
              <img src={info_blue} />
            </button>


          </div>

          <div className="main-sidebar__right-box">
            <div className="main-sidebar__group-btn">

              <NotificationChat
                setIsModalChat={setIsModalChat}
              />

              <Link
                tabIndex={-1}
                className='main-sidebar__load'
                to="/settings/download-history">
                <ButtonWithIcon
                  icon={load}
                  label={'Загрузки'}
                />
              </Link>

              <ButtonWithIcon
                icon={bell}
                label={'Обучение'}
                onClick={(e) => {
                  setIsModalKnowledgeBase(true);
                }}
              />

              <ButtonWithIcon
                className='notif'
                icon={question}
                label={'Уведомления'}
                onClick={(e) => {
                  setShowNotificationBox(true)
                }}
                count={notifCount?.total}
              />

              <Link
                tabIndex={-1}
                to="/settings/space">
                <ButtonWithIcon
                  icon={settings}
                  label={'Настройки'}
                />
              </Link>

            </div>

            <button
              className="btn-balance"
              onClick={(e) => navigate('/settings/tariff/tariffs')}
            >
              <span>
                {`${balance} ${currency} | ${tariffInSpace?.tariff?.portal_name?.toUpperCase() || 'Тариф не выбран'}`}
              </span>

              <Tooltip
                className='btn-balance__icon-wrap'
                text={returnStatus(tariffInSpace?.status)?.[1]}
                maxWidth='160px'
                theme='light'
                child={
                  <img
                    className='btn-balance__icon'
                    alt='Статус подключения'
                    src={returnStatus(tariffInSpace?.status)?.[0]}
                  />
                }
              />

              {
                (tariffInSpace?.days_left && (tariffInSpace?.days_left < 8))
                  ?
                  < Tooltip
                    className='btn-balance__icon-wrap_right'
                    text={`До окончания тарифа осталось ${tariffInSpace?.days_left} дней. 
                    ${tariffInSpace?.required_topup ? `Пополните баланс на ${tariffInSpace?.required_topup} руб.` : ''}`}
                    maxWidth='160px'
                    theme='light'
                    child={
                      <div className='btn-balance__status' style={{ background: tariffInSpace?.days_left < 5 ? 'rgb(255 42 42 / 69%)' : '' }}>
                        {tariffInSpace?.days_left + ' дн.'}
                      </div>
                    }
                  /> : null}
            </button>

            <div className="profile-box">
              <p className="profile-box__user-name">{profileName}</p>
              <div
                className="profile-list__content"
                onClick={(e) => {
                  setProfileSettings(!showProfileSettings);
                }}
              >
                <button className="profile-box__btn">
                  {profileName?.length > 0 && profileName[0]?.toUpperCase()}
                </button>

                <ProfileSettings
                  showProfileSettings={showProfileSettings}
                  onLogOutHandler={(e) => onLogOutHandler(e)}
                />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export { HeaderMain };
